import axios from "./axios";
import Cookies from "js-cookie";

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    Cookies.set("__afritas_token", accessToken, {
      domain: ".useafritas.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
  } else {
    localStorage.removeItem("accessToken");
    Cookies.remove("__afritas_token", {
      domain: ".useafritas.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
  }
};
const setHeader = () => {
  const accessToken = window.localStorage.getItem("accessToken")
    ? window.localStorage.getItem("accessToken")
    : "";
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};
const setHideWallet = (isHidden) => {
  if (isHidden) {
    localStorage.setItem("hideWallet", "true");
  } else {
    localStorage.removeItem("hideWallet");
  }
};
const getHideWallet = () => window.localStorage.getItem("hideWallet") || "";

export { setSession, setHeader, setHideWallet, getHideWallet };
